import { useContext } from "react";

// icons
import { CloseIcon } from "../../../../assets/icons/CloseIcon";

// helpers
import { generateSkinImage } from "../../../../helpers/generateSkinImage";

// contexts
import { cartContext } from "../../../../context/cart-provider/CartProvider";
import { currencyContext } from "../../../../context/currency-provider/CurrencyProvider";

// types
import type { UpdatedSkinType } from "../../../../context/skin-provider/SkinProvider.types";

// styles
import styles from "./CartProduct.module.scss";

type CartProductProps = {
  product: UpdatedSkinType;
};

export function CartProduct({ product }: CartProductProps) {
  const { deleteSkinFromCart } = useContext(cartContext);
  const { getCurrencySymbol } = useContext(currencyContext);

  return (
    <div className={styles.container}>
      <div className={styles.productWrapper}>
        <div className={styles.productInfo}>
          <div className={styles.imageWrapper}>
            <img src={generateSkinImage(product.class_id)} alt={product.name} />
          </div>
          <div className={styles.info}>
            <p className={styles.title}>{product.name}</p>
          </div>
        </div>
        <p className={styles.price}>
          {getCurrencySymbol()} {product.price}
        </p>
      </div>
      <div className={styles.divider}></div>
      <div className={styles.totalPriceWrapper}>
        <p>
          {getCurrencySymbol()} {(product.price ?? 0).toFixed(2)}
        </p>
        <div
          className={styles.removeWrapper}
          onClick={() => deleteSkinFromCart(product.id)}
        >
          <CloseIcon color="#a21916" width={13} height={13} /> Remove
        </div>
      </div>
    </div>
  );
}
